import React, { useEffect, useMemo, useState, Fragment } from 'react';
import { TrendingUp, Clock, BarChart3, Wallet, CreditCard, Plus, AlertCircle, ArrowDownToLine, Search, ChevronDown, ChevronUp, Download, X, CheckCircle2, FileText, ArrowUpRight, ArrowDownRight, RefreshCcw, Percent, Crown, Megaphone, Receipt, PiggyBank, ArrowRight, ArrowLeft, Shield, Loader2, Check, Smartphone } from 'lucide-react';
import { Card } from '../ui/Card';
import { Button } from '../ui/Button';
import { Badge } from '../ui/Badge';
import { Input } from '../ui/Input';
import { Pagination } from '../ui/Pagination';
interface FinancesTabProps {
  showToast: (msg: string) => void;
  setActiveTab?: (tab: string) => void;
}
type TxType = 'income' | 'withdrawal' | 'refund' | 'commission' | 'subscription' | 'advertising';
type TxStatus = 'completed' | 'pending' | 'failed';
interface Transaction {
  id: string;
  date: string;
  type: TxType;
  description: string;
  amount: number;
  status: TxStatus;
  orderId?: string;
  clientName?: string;
  serviceName?: string;
  commissionPercent?: number;
  commissionAmount?: number;
  netAmount?: number;
  source?: string;
}
interface PaymentMethod {
  id: string;
  type: 'card' | 'crypto' | 'paypal';
  name: string;
  details: string;
  isDefault: boolean;
}
const MOCK_TRANSACTIONS: Transaction[] = [{
  id: 'tx-sub-3',
  date: '2024-10-15T00:01:00',
  type: 'subscription',
  description: 'Подписка PRO — Октябрь',
  amount: -990,
  status: 'completed',
  source: 'balance'
}, {
  id: 'tx-ad-2',
  date: '2024-10-14T18:00:00',
  type: 'advertising',
  description: 'Реклама: Баннер в каталоге',
  amount: -1500,
  status: 'completed',
  source: 'balance'
}, {
  id: 'tx-1042',
  date: '2024-10-15T14:30:00',
  type: 'income',
  description: 'Оплата заказа #1042',
  amount: 5000,
  status: 'completed',
  orderId: 'ORD-1042',
  clientName: 'Елена Смирнова',
  serviceName: 'Натальная карта',
  commissionPercent: 15,
  commissionAmount: 750,
  netAmount: 4250
}, {
  id: 'tx-1041',
  date: '2024-10-14T11:15:00',
  type: 'income',
  description: 'Оплата заказа #1041',
  amount: 6000,
  status: 'completed',
  orderId: 'ORD-1041',
  clientName: 'Дмитрий В.',
  serviceName: 'Синастрия',
  commissionPercent: 15,
  commissionAmount: 900,
  netAmount: 5100
}, {
  id: 'tx-w1',
  date: '2024-10-10T09:00:00',
  type: 'withdrawal',
  description: 'Вывод средств на карту *4276',
  amount: -32000,
  status: 'completed',
  commissionPercent: 0,
  commissionAmount: 0,
  netAmount: -32000
}, {
  id: 'tx-ad-1',
  date: '2024-10-05T12:00:00',
  type: 'advertising',
  description: 'Реклама: Закрепление в категории',
  amount: -2000,
  status: 'completed',
  source: 'balance'
}, {
  id: 'tx-sub-2',
  date: '2024-09-15T00:01:00',
  type: 'subscription',
  description: 'Подписка PRO — Сентябрь',
  amount: -990,
  status: 'completed',
  source: 'card'
}, {
  id: 'tx-1030',
  date: '2024-10-01T16:45:00',
  type: 'income',
  description: 'Оплата заказа #1030',
  amount: 5000,
  status: 'completed',
  orderId: 'ORD-1030',
  clientName: 'Анна К.',
  serviceName: 'Натальная карта',
  commissionPercent: 15,
  commissionAmount: 750,
  netAmount: 4250
}, {
  id: 'tx-1029',
  date: '2024-09-28T20:10:00',
  type: 'income',
  description: 'Покупка товара',
  amount: 990,
  status: 'completed',
  orderId: 'ORD-1029',
  clientName: 'Иван П.',
  serviceName: 'Вебинар Меркурий',
  commissionPercent: 10,
  commissionAmount: 99,
  netAmount: 891
}, {
  id: 'tx-r1',
  date: '2024-09-20T12:00:00',
  type: 'refund',
  description: 'Возврат по заказу #1020',
  amount: -5000,
  status: 'completed',
  orderId: 'ORD-1020',
  clientName: 'Мария Л.',
  serviceName: 'Натальная карта'
}, {
  id: 'tx-w2',
  date: '2024-09-15T10:30:00',
  type: 'withdrawal',
  description: 'Вывод средств на карту *4276',
  amount: -28500,
  status: 'completed',
  commissionPercent: 0,
  commissionAmount: 0,
  netAmount: -28500
}, {
  id: 'tx-1015',
  date: '2024-09-10T15:20:00',
  type: 'income',
  description: 'Оплата заказа #1015',
  amount: 15000,
  status: 'completed',
  orderId: 'ORD-1015',
  clientName: 'Ольга В.',
  serviceName: 'Соляр на год',
  commissionPercent: 15,
  commissionAmount: 2250,
  netAmount: 12750
}, {
  id: 'tx-1043',
  date: '2024-10-16T08:00:00',
  type: 'income',
  description: 'Оплата заказа #1043',
  amount: 4500,
  status: 'pending',
  orderId: 'ORD-1043',
  clientName: 'Сергей М.',
  serviceName: 'Экспресс-консультация',
  commissionPercent: 15,
  commissionAmount: 675,
  netAmount: 3825
}, {
  id: 'tx-1044',
  date: '2024-10-16T09:30:00',
  type: 'income',
  description: 'Оплата заказа #1044',
  amount: 4500,
  status: 'pending',
  orderId: 'ORD-1044',
  clientName: 'Алина Т.',
  serviceName: 'Экспресс-консультация',
  commissionPercent: 15,
  commissionAmount: 675,
  netAmount: 3825
}];
const MOCK_METHODS: PaymentMethod[] = [{
  id: 'pm-1',
  type: 'card',
  name: 'Сбербанк',
  details: 'Visa •••• 4276',
  isDefault: true
}];
const SERVICES_INCOME = [{
  name: 'Натальная карта',
  amount: 210000,
  percent: 100,
  color: 'bg-indigo-500'
}, {
  name: 'Соляр на год',
  amount: 112000,
  percent: 53,
  color: 'bg-indigo-400'
}, {
  name: 'Синастрия',
  amount: 90000,
  percent: 43,
  color: 'bg-indigo-300'
}, {
  name: 'Товары',
  amount: 44550,
  percent: 21,
  color: 'bg-indigo-200'
}];
export function FinancesTab({
  showToast,
  setActiveTab
}: FinancesTabProps) {
  // State
  const [transactions, setTransactions] = useState<Transaction[]>(MOCK_TRANSACTIONS);
  const [methods, setMethods] = useState<PaymentMethod[]>(MOCK_METHODS);
  // Modals & Forms
  const [showWithdrawModal, setShowWithdrawModal] = useState(false);
  const [withdrawAmount, setWithdrawAmount] = useState('');
  const [selectedMethodId, setSelectedMethodId] = useState(MOCK_METHODS[0].id);
  const [addingCard, setAddingCard] = useState(false);
  const [newCard, setNewCard] = useState({
    number: '',
    name: ''
  });
  const [showDownloadModal, setShowDownloadModal] = useState(false);
  const [downloadPeriod, setDownloadPeriod] = useState('month');
  const [downloadType, setDownloadType] = useState('all');
  // Top-up flow
  const [showTopupModal, setShowTopupModal] = useState(false);
  const [topupStep, setTopupStep] = useState(0); // 0=amount, 1=method, 2=card, 3=sms, 4=processing, 5=success
  const [topupAmount, setTopupAmount] = useState<number | null>(null);
  const [topupCustom, setTopupCustom] = useState('');
  const [topupMethod, setTopupMethod] = useState<string | null>(null);
  const [topupCardNumber, setTopupCardNumber] = useState('');
  const [topupCardExpiry, setTopupCardExpiry] = useState('');
  const [topupCardCvv, setTopupCardCvv] = useState('');
  const [topupCardName, setTopupCardName] = useState('');
  const [topupSaveCard, setTopupSaveCard] = useState(true);
  const [topupSmsCode, setTopupSmsCode] = useState('');
  const [topupSmsTimer, setTopupSmsTimer] = useState(60);
  const [topupSmsSent, setTopupSmsSent] = useState(false);
  // Filters & UI State
  const [searchQuery, setSearchQuery] = useState('');
  const [showFilters, setShowFilters] = useState(false);
  const [filterType, setFilterType] = useState<TxType | 'all'>('all');
  const [filterStatus, setFilterStatus] = useState<TxStatus | 'all'>('all');
  const [expandedTxId, setExpandedTxId] = useState<string | null>(null);
  const [showAllIncomeServices, setShowAllIncomeServices] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const ITEMS_PER_PAGE = 10;
  // Unified Balance
  const mainBalance = 24500;
  const pendingAmount = 9000;
  const totalBalance = mainBalance + pendingAmount;
  const earnedThisMonth = 48000;
  const totalEarned = 324500;
  // Expenses
  const subscriptionExpense = 990;
  const advertisingExpense = 3500;
  const commissionExpense = 5325;
  const totalExpenses = subscriptionExpense + advertisingExpense + commissionExpense;
  // Ad budget
  const adBudgetBalance = 4500;
  // Derived Data
  const availableToWithdraw = 24500;
  const filteredTransactions = useMemo(() => {
    return transactions.filter(tx => {
      const matchesSearch = tx.description.toLowerCase().includes(searchQuery.toLowerCase()) || tx.orderId && tx.orderId.toLowerCase().includes(searchQuery.toLowerCase()) || tx.clientName && tx.clientName.toLowerCase().includes(searchQuery.toLowerCase());
      const matchesType = filterType === 'all' || tx.type === filterType;
      const matchesStatus = filterStatus === 'all' || tx.status === filterStatus;
      return matchesSearch && matchesType && matchesStatus;
    }).sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());
  }, [transactions, searchQuery, filterType, filterStatus]);
  // Reset page on filter change
  useEffect(() => {
    setCurrentPage(1);
  }, [searchQuery, filterType, filterStatus]);
  const totalPages = Math.ceil(filteredTransactions.length / ITEMS_PER_PAGE);
  const paginatedTransactions = filteredTransactions.slice((currentPage - 1) * ITEMS_PER_PAGE, currentPage * ITEMS_PER_PAGE);
  // Handlers
  const handleWithdraw = () => {
    const amount = parseInt(withdrawAmount.replace(/\D/g, ''), 10);
    if (isNaN(amount) || amount < 1000) {
      showToast('Минимальная сумма вывода: 1 000 ₽');
      return;
    }
    if (amount > availableToWithdraw) {
      showToast('Недостаточно средств для вывода');
      return;
    }
    const newTx: Transaction = {
      id: `tx-w-${Date.now()}`,
      date: new Date().toISOString(),
      type: 'withdrawal',
      description: `Вывод средств на ${methods.find(m => m.id === selectedMethodId)?.details}`,
      amount: -amount,
      status: 'pending',
      commissionPercent: 0,
      commissionAmount: 0,
      netAmount: -amount
    };
    setTransactions([newTx, ...transactions]);
    setShowWithdrawModal(false);
    setWithdrawAmount('');
    showToast('Заявка на вывод успешно создана');
    console.log(`[Admin Sync] Withdrawal requested: ${amount} RUB to ${selectedMethodId}`);
  };
  const handleAddCard = () => {
    if (!newCard.number || !newCard.name) {
      showToast('Заполните все поля');
      return;
    }
    const method: PaymentMethod = {
      id: `pm-${Date.now()}`,
      type: 'card',
      name: 'Новая карта',
      details: `Visa •••• ${newCard.number.slice(-4)}`,
      isDefault: false
    };
    setMethods([...methods, method]);
    setAddingCard(false);
    setNewCard({
      number: '',
      name: ''
    });
    showToast('Карта успешно добавлена');
    console.log(`[Admin Sync] New payment method added: ${method.id}`);
  };
  const handleDownload = () => {
    setShowDownloadModal(false);
    showToast('Файл выписки формируется и скоро будет скачан');
    console.log(`[Admin Sync] Statement downloaded: period=${downloadPeriod}, type=${downloadType}`);
  };
  const handleCardClick = (type: TxType | 'all', status: TxStatus | 'all' = 'all') => {
    setFilterType(type);
    setFilterStatus(status);
    setSearchQuery('');
    // Scroll to transactions
    document.getElementById('transactions-section')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const TOPUP_AMOUNTS_ASTRO = [3000, 5000, 10000, 20000];
  const TOPUP_METHODS = [{
    id: 'card',
    label: 'Банковская карта',
    desc: 'Visa, Mastercard, МИР',
    icon: <CreditCard className="w-5 h-5" data-id="element-13268" />
  }, {
    id: 'apple',
    label: 'Apple Pay',
    desc: 'Быстрая оплата',
    icon: <Smartphone className="w-5 h-5" data-id="element-13269" />
  }, {
    id: 'google',
    label: 'Google Pay',
    desc: 'Быстрая оплата',
    icon: <Smartphone className="w-5 h-5" data-id="element-13270" />
  }];
  const topupFinalAmount = topupAmount || parseInt(topupCustom) || 0;
  const resetTopup = () => {
    setShowTopupModal(false);
    setTopupStep(0);
    setTopupAmount(null);
    setTopupCustom('');
    setTopupMethod(null);
    setTopupCardNumber('');
    setTopupCardExpiry('');
    setTopupCardCvv('');
    setTopupCardName('');
    setTopupSmsCode('');
    setTopupSmsTimer(60);
    setTopupSmsSent(false);
  };
  const openTopup = () => {
    setShowTopupModal(true);
    setTopupStep(0);
  };
  // SMS countdown
  useEffect(() => {
    if (showTopupModal && topupStep === 3 && topupSmsTimer > 0) {
      const t = setTimeout(() => setTopupSmsTimer(v => v - 1), 1000);
      return () => clearTimeout(t);
    }
  }, [showTopupModal, topupStep, topupSmsTimer]);
  useEffect(() => {
    if (showTopupModal && topupStep === 3 && !topupSmsSent) {
      setTopupSmsSent(true);
      setTopupSmsTimer(60);
    }
  }, [showTopupModal, topupStep, topupSmsSent]);
  // Processing auto-advance
  useEffect(() => {
    if (showTopupModal && topupStep === 4) {
      const t = setTimeout(() => setTopupStep(5), 2500);
      return () => clearTimeout(t);
    }
  }, [showTopupModal, topupStep]);
  const fmtCardNum = (v: string) => {
    const d = v.replace(/\D/g, '').slice(0, 16);
    return d.replace(/(.{4})/g, '$1 ').trim();
  };
  const fmtExp = (v: string) => {
    const d = v.replace(/\D/g, '').slice(0, 4);
    return d.length > 2 ? d.slice(0, 2) + '/' + d.slice(2) : d;
  };
  const isTopupCardValid = topupCardNumber.replace(/\s/g, '').length === 16 && topupCardExpiry.length === 5 && topupCardCvv.length >= 3 && topupCardName.length >= 2;
  // Formatters
  const formatMoney = (amount: number) => {
    return new Intl.NumberFormat('ru-RU', {
      style: 'currency',
      currency: 'RUB',
      maximumFractionDigits: 0
    }).format(amount);
  };
  const formatDate = (dateStr: string) => {
    return new Intl.DateTimeFormat('ru-RU', {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    }).format(new Date(dateStr));
  };
  const getTypeConfig = (type: TxType) => {
    switch (type) {
      case 'income':
        return {
          label: 'Доход',
          color: 'text-emerald-600',
          bg: 'bg-emerald-50',
          icon: <ArrowDownRight className="w-4 h-4" data-id="element-13271" />
        };
      case 'withdrawal':
        return {
          label: 'Вывод',
          color: 'text-slate-900',
          bg: 'bg-slate-100',
          icon: <ArrowUpRight className="w-4 h-4" data-id="element-13272" />
        };
      case 'refund':
        return {
          label: 'Возврат',
          color: 'text-rose-600',
          bg: 'bg-rose-50',
          icon: <RefreshCcw className="w-4 h-4" data-id="element-13273" />
        };
      case 'commission':
        return {
          label: 'Комиссия',
          color: 'text-amber-600',
          bg: 'bg-amber-50',
          icon: <Percent className="w-4 h-4" data-id="element-13274" />
        };
      case 'subscription':
        return {
          label: 'Подписка',
          color: 'text-indigo-600',
          bg: 'bg-indigo-50',
          icon: <Crown className="w-4 h-4" data-id="element-13275" />
        };
      case 'advertising':
        return {
          label: 'Реклама',
          color: 'text-purple-600',
          bg: 'bg-purple-50',
          icon: <Megaphone className="w-4 h-4" data-id="element-13276" />
        };
    }
  };
  const getStatusBadge = (status: TxStatus) => {
    switch (status) {
      case 'completed':
        return <Badge variant="success" size="sm" data-id="element-13277">
            Выполнено
          </Badge>;
      case 'pending':
        return <Badge variant="warning" size="sm" data-id="element-13278">
            В обработке
          </Badge>;
      case 'failed':
        return <Badge variant="error" size="sm" data-id="element-13279">
            Ошибка
          </Badge>;
    }
  };
  return <div className="space-y-6 pb-20 sm:pb-0" data-id="element-13280">
      {/* Header */}
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 mb-2" data-id="element-13281">
        <div data-id="element-13282">
          <h2 className="text-2xl font-bold text-slate-900" data-id="element-13283">Финансы</h2>
          <p className="text-slate-500 text-sm mt-1" data-id="element-13284">
            Единый баланс · Доходы · Расходы · Выводы
          </p>
        </div>
        <Button variant="outline" icon={<ArrowDownToLine className="w-4 h-4" data-id="element-13286" />} onClick={() => setShowDownloadModal(true)} className="w-full sm:w-auto" data-id="element-13285">
          Скачать выписку
        </Button>
      </div>

      {/* Unified Balance */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 xl:grid-cols-5 gap-3 sm:gap-4" data-id="element-13287">
        {/* Main Balance Card */}
        <Card padding="md" className="bg-slate-900 text-white border-none flex flex-col justify-between col-span-1 sm:col-span-2 lg:col-span-2 relative overflow-hidden group cursor-pointer" onClick={() => handleCardClick('all', 'completed')} data-id="element-13288">
          <div className="absolute top-0 right-0 p-4 opacity-10 group-hover:opacity-20 transition-opacity" data-id="element-13289">
            <Wallet className="w-16 h-16 sm:w-24 sm:h-24" data-id="element-13290" />
          </div>
          <div className="relative z-10" data-id="element-13291">
            <div className="text-slate-400 text-xs sm:text-sm mb-1 font-medium" data-id="element-13292">
              Общий баланс
            </div>
            <div className="text-2xl sm:text-3xl lg:text-4xl font-bold mb-0.5 break-words" data-id="element-13293">
              {formatMoney(totalBalance)}
            </div>
            <div className="flex flex-wrap gap-x-3 gap-y-1 text-xs sm:text-sm mb-3 sm:mb-4" data-id="element-13294">
              <span className="text-emerald-400 whitespace-nowrap" data-id="element-13295">
                Доступно: {formatMoney(mainBalance)}
              </span>
              <span className="text-amber-400 whitespace-nowrap" data-id="element-13296">
                В ожидании: {formatMoney(pendingAmount)}
              </span>
            </div>
            <div className="text-slate-400 text-[11px] sm:text-xs mb-3 sm:mb-4" data-id="element-13297">
              Используется для вывода, подписки и рекламы
            </div>
          </div>
          <div className="relative z-10 grid grid-cols-2 gap-2" data-id="element-13298">
            <Button variant="primary" size="md" className="bg-emerald-600 hover:bg-emerald-500 text-white border-none shadow-lg shadow-emerald-900/20 text-xs sm:text-sm whitespace-nowrap" onClick={e => {
            e.stopPropagation();
            openTopup();
          }} data-id="element-13299">
              <Plus className="w-3.5 h-3.5 mr-1 shrink-0" data-id="element-13300" /> Пополнить
            </Button>
            <Button variant="primary" size="md" className="bg-indigo-600 hover:bg-indigo-500 text-white border-none shadow-lg shadow-indigo-900/20 text-xs sm:text-sm whitespace-nowrap" onClick={e => {
            e.stopPropagation();
            setShowWithdrawModal(true);
          }} data-id="element-13301">
              Вывести
            </Button>
          </div>
        </Card>

        {/* Income this month */}
        <Card padding="md" className="flex flex-col justify-between cursor-pointer hover:border-indigo-300 transition-colors min-w-0 overflow-hidden" onClick={() => handleCardClick('income')} data-id="element-13302">
          <div className="min-w-0" data-id="element-13303">
            <div className="text-slate-500 text-[11px] sm:text-xs lg:text-sm mb-1 font-medium leading-tight" data-id="element-13304">
              Доход за месяц
            </div>
            <div className="text-lg sm:text-xl xl:text-2xl font-bold text-slate-900 mb-2 leading-tight" data-id="element-13305">
              {formatMoney(earnedThisMonth)}
            </div>
          </div>
          <div className="text-[10px] sm:text-xs text-emerald-600 flex items-center font-medium bg-emerald-50 w-fit px-1.5 py-0.5 sm:px-2 sm:py-1 rounded-md" data-id="element-13306">
            <TrendingUp className="w-3 h-3 sm:w-3.5 sm:h-3.5 mr-1 shrink-0" data-id="element-13307" />{' '}
            +12%
          </div>
        </Card>

        {/* Expenses this month */}
        <Card padding="md" className="flex flex-col justify-between cursor-pointer hover:border-rose-300 transition-colors min-w-0 overflow-hidden" onClick={() => {
        setFilterType('all');
        setFilterStatus('all');
        document.getElementById('expenses-section')?.scrollIntoView({
          behavior: 'smooth'
        });
      }} data-id="element-13308">
          <div className="min-w-0" data-id="element-13309">
            <div className="text-slate-500 text-[11px] sm:text-xs lg:text-sm mb-1 font-medium leading-tight" data-id="element-13310">
              Расходы
            </div>
            <div className="text-lg sm:text-xl xl:text-2xl font-bold text-slate-900 mb-2 leading-tight" data-id="element-13311">
              {formatMoney(totalExpenses)}
            </div>
          </div>
          <div className="text-[10px] sm:text-xs text-rose-600 flex items-center font-medium bg-rose-50 w-fit px-1.5 py-0.5 sm:px-2 sm:py-1 rounded-md" data-id="element-13312">
            <Receipt className="w-3 h-3 sm:w-3.5 sm:h-3.5 mr-1 shrink-0" data-id="element-13313" />{' '}
            Подписка
          </div>
        </Card>

        <Card padding="md" className="flex flex-col justify-between cursor-pointer hover:border-indigo-300 transition-colors min-w-0 overflow-hidden" onClick={() => handleCardClick('income')} data-id="element-13314">
          <div className="min-w-0" data-id="element-13315">
            <div className="text-slate-500 text-[11px] sm:text-xs lg:text-sm mb-1 font-medium leading-tight" data-id="element-13316">
              Всего
            </div>
            <div className="text-lg sm:text-xl xl:text-2xl font-bold text-slate-900 mb-2 leading-tight" data-id="element-13317">
              {formatMoney(totalEarned)}
            </div>
          </div>
          <div className="text-[10px] sm:text-xs text-indigo-600 flex items-center font-medium bg-indigo-50 w-fit px-1.5 py-0.5 sm:px-2 sm:py-1 rounded-md" data-id="element-13318">
            <BarChart3 className="w-3 h-3 sm:w-3.5 sm:h-3.5 mr-1 shrink-0" data-id="element-13319" /> За
            всё время
          </div>
        </Card>
      </div>

      {/* Expenses Breakdown */}
      <div id="expenses-section" data-id="element-13320">
        <Card padding="md" data-id="element-13321">
          <div className="flex justify-between items-center mb-4" data-id="element-13322">
            <h3 className="font-bold text-slate-900 flex items-center gap-2" data-id="element-13323">
              <Receipt className="w-5 h-5 text-rose-500" data-id="element-13324" /> Расходы за месяц
            </h3>
            <span className="text-sm font-bold text-slate-900" data-id="element-13325">
              {formatMoney(totalExpenses)}
            </span>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 mb-4" data-id="element-13326">
            <div className="p-3 bg-indigo-50 rounded-xl border border-indigo-100 cursor-pointer hover:border-indigo-300 transition-colors" onClick={() => {
            setFilterType('subscription');
            document.getElementById('transactions-section')?.scrollIntoView({
              behavior: 'smooth'
            });
          }} data-id="element-13327">
              <div className="flex items-center gap-2 mb-1" data-id="element-13328">
                <Crown className="w-4 h-4 text-indigo-600" data-id="element-13329" />
                <span className="text-xs font-medium text-indigo-600" data-id="element-13330">
                  Подписка
                </span>
              </div>
              <div className="text-lg font-bold text-slate-900" data-id="element-13331">
                {formatMoney(subscriptionExpense)}
              </div>
              <div className="text-[10px] text-slate-500 mt-0.5" data-id="element-13332">
                PRO · списание с баланса
              </div>
            </div>
            <div className="p-3 bg-purple-50 rounded-xl border border-purple-100 cursor-pointer hover:border-purple-300 transition-colors" onClick={() => {
            setFilterType('advertising');
            document.getElementById('transactions-section')?.scrollIntoView({
              behavior: 'smooth'
            });
          }} data-id="element-13333">
              <div className="flex items-center gap-2 mb-1" data-id="element-13334">
                <Megaphone className="w-4 h-4 text-purple-600" data-id="element-13335" />
                <span className="text-xs font-medium text-purple-600" data-id="element-13336">
                  Реклама
                </span>
              </div>
              <div className="text-lg font-bold text-slate-900" data-id="element-13337">
                {formatMoney(advertisingExpense)}
              </div>
              <div className="text-[10px] text-slate-500 mt-0.5" data-id="element-13338">
                Баланс рекламы: {formatMoney(adBudgetBalance)}
              </div>
            </div>
            <div className="p-3 bg-amber-50 rounded-xl border border-amber-100 cursor-pointer hover:border-amber-300 transition-colors" onClick={() => {
            setFilterType('commission');
            document.getElementById('transactions-section')?.scrollIntoView({
              behavior: 'smooth'
            });
          }} data-id="element-13339">
              <div className="flex items-center gap-2 mb-1" data-id="element-13340">
                <Percent className="w-4 h-4 text-amber-600" data-id="element-13341" />
                <span className="text-xs font-medium text-amber-600" data-id="element-13342">
                  Комиссия платформы
                </span>
              </div>
              <div className="text-lg font-bold text-slate-900" data-id="element-13343">
                {formatMoney(commissionExpense)}
              </div>
              <div className="text-[10px] text-slate-500 mt-0.5" data-id="element-13344">
                15% от заказов
              </div>
            </div>
          </div>
          <div className="bg-slate-50 rounded-lg p-3 border border-slate-100 flex items-center justify-between" data-id="element-13345">
            <div className="text-sm text-slate-600" data-id="element-13346">
              <span className="font-medium text-slate-900" data-id="element-13347">Прозрачность:</span>{' '}
              каждый заказ показывает сумму, комиссию и чистый доход
            </div>
            <ArrowRight className="w-4 h-4 text-slate-400" data-id="element-13348" />
          </div>
        </Card>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-13349">
        {/* Section 2: Способ вывода */}
        <Card padding="md" className="lg:col-span-2" data-id="element-13350">
          <div className="flex justify-between items-center mb-6" data-id="element-13351">
            <h3 className="font-bold text-slate-900 flex items-center gap-2" data-id="element-13352">
              <Wallet className="w-5 h-5 text-indigo-500" data-id="element-13353" /> Способ вывода
              средств
            </h3>
            {!addingCard && <Button variant="ghost" size="sm" icon={<Plus className="w-4 h-4" data-id="element-13355" />} onClick={() => setAddingCard(true)} data-id="element-13354">
                Добавить карту
              </Button>}
          </div>

          {addingCard ? <div className="bg-slate-50 border border-slate-200 rounded-xl p-5 mb-4 animate-in fade-in slide-in-from-top-2" data-id="element-13356">
              <h4 className="text-sm font-bold text-slate-900 mb-4" data-id="element-13357">
                Добавление новой карты
              </h4>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4" data-id="element-13358">
                <Input label="Номер карты" placeholder="0000 0000 0000 0000" value={newCard.number} onChange={e => setNewCard({
              ...newCard,
              number: e.target.value
            })} data-id="element-13359" />
                <Input label="Имя владельца (как на карте)" placeholder="IVAN IVANOV" value={newCard.name} onChange={e => setNewCard({
              ...newCard,
              name: e.target.value
            })} data-id="element-13360" />
              </div>
              <div className="flex gap-3 justify-end" data-id="element-13361">
                <Button variant="outline" onClick={() => setAddingCard(false)} data-id="element-13362">
                  Отмена
                </Button>
                <Button variant="primary" onClick={handleAddCard} data-id="element-13363">
                  Сохранить карту
                </Button>
              </div>
            </div> : <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4" data-id="element-13364">
              {methods.map(method => <div key={method.id} className={`border rounded-xl p-4 cursor-pointer transition-all ${selectedMethodId === method.id ? 'border-indigo-500 bg-indigo-50/30 ring-1 ring-indigo-500' : 'border-slate-200 hover:border-indigo-300 bg-white'}`} onClick={() => setSelectedMethodId(method.id)} data-id="element-13365">
                  <div className="flex items-center justify-between mb-3" data-id="element-13366">
                    <div className="flex items-center gap-3" data-id="element-13367">
                      <div className="w-10 h-10 bg-white rounded-lg shadow-sm flex items-center justify-center border border-slate-100" data-id="element-13368">
                        <CreditCard className="w-5 h-5 text-slate-700" data-id="element-13369" />
                      </div>
                      <div data-id="element-13370">
                        <div className="font-bold text-slate-900" data-id="element-13371">
                          {method.details}
                        </div>
                        <div className="text-xs text-slate-500" data-id="element-13372">
                          {method.name}
                        </div>
                      </div>
                    </div>
                    {method.isDefault && <Badge variant="success" size="sm" data-id="element-13373">
                        Основная
                      </Badge>}
                  </div>
                  <div className="flex justify-end" data-id="element-13374">
                    <Button variant="ghost" size="sm" className="text-slate-400 hover:text-indigo-600 h-8 px-2" onClick={e => {
                e.stopPropagation();
                setAddingCard(true);
                showToast('Заполните данные новой карты');
              }} data-id="element-13375">
                      Изменить
                    </Button>
                  </div>
                </div>)}
            </div>}

          <div className="bg-slate-50 rounded-lg p-4 flex items-start gap-3 border border-slate-100" data-id="element-13376">
            <AlertCircle className="w-5 h-5 text-indigo-500 flex-shrink-0 mt-0.5" data-id="element-13377" />
            <div className="text-sm text-slate-600" data-id="element-13378">
              <p className="font-medium text-slate-900 mb-1" data-id="element-13379">
                Условия вывода средств
              </p>
              <ul className="list-disc list-inside space-y-1 text-slate-500" data-id="element-13380">
                <li data-id="element-13381">
                  Комиссия за вывод:{' '}
                  <strong className="text-slate-700" data-id="element-13382">0%</strong>
                </li>
                <li data-id="element-13383">
                  Срок зачисления:{' '}
                  <strong className="text-slate-700" data-id="element-13384">1-3 рабочих дня</strong>
                </li>
                <li data-id="element-13385">
                  Минимальная сумма вывода:{' '}
                  <strong className="text-slate-700" data-id="element-13386">1 000 ₽</strong>
                </li>
              </ul>
            </div>
          </div>
        </Card>

        {/* Section 3: Доход по услугам */}
        <Card padding="md" data-id="element-13387">
          <h3 className="font-bold text-slate-900 mb-6 flex items-center gap-2" data-id="element-13388">
            <BarChart3 className="w-5 h-5 text-indigo-500" data-id="element-13389" /> Доход по услугам
          </h3>

          <div className="space-y-5" data-id="element-13390">
            {(showAllIncomeServices ? SERVICES_INCOME : SERVICES_INCOME.slice(0, 4)).map((item, i) => <div key={i} className="group cursor-pointer" onClick={() => {
            if (setActiveTab) setActiveTab('orders');else showToast(`Заказы: ${item.name}`);
          }} data-id="element-13391">
                <div className="flex justify-between text-sm mb-2" data-id="element-13392">
                  <span className="font-medium text-slate-700 group-hover:text-indigo-600 transition-colors" data-id="element-13393">
                    {item.name}
                  </span>
                  <span className="font-bold text-slate-900" data-id="element-13394">
                    {formatMoney(item.amount)}
                  </span>
                </div>
                <div className="w-full bg-slate-100 rounded-full h-2 overflow-hidden" data-id="element-13395">
                  <div className={`h-full rounded-full ${item.color} transition-all duration-500`} style={{
                width: `${item.percent}%`
              }} data-id="element-13396"></div>
                </div>
              </div>)}
          </div>

          {SERVICES_INCOME.length > 4 && <button onClick={() => setShowAllIncomeServices(!showAllIncomeServices)} className="w-full mt-4 text-sm font-medium text-indigo-600 hover:text-indigo-700 flex items-center justify-center gap-1 transition-colors" data-id="element-13397">
              {showAllIncomeServices ? 'Свернуть' : `Ещё ${SERVICES_INCOME.length - 4} услуг`}
            </button>}

          <Button variant="outline" fullWidth className="mt-4" onClick={() => {
          if (setActiveTab) setActiveTab('services');else showToast('Переход ко всем услугам');
        }} data-id="element-13398">
            Смотреть все услуги
          </Button>
        </Card>
      </div>

      {/* Section 4: История транзакций */}
      <Card padding="none" className="overflow-hidden" id="transactions-section" data-id="element-13399">
        <div className="p-4 sm:p-6 border-b border-slate-100" data-id="element-13400">
          <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 mb-4" data-id="element-13401">
            <h3 className="font-bold text-slate-900 text-lg" data-id="element-13402">
              История транзакций
            </h3>

            <div className="flex w-full sm:w-auto gap-2" data-id="element-13403">
              <div className="relative flex-1 sm:w-64" data-id="element-13404">
                <Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" data-id="element-13405" />
                <input type="text" placeholder="Поиск по ID или клиенту..." className="w-full pl-9 pr-4 py-2 bg-slate-50 border border-slate-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 transition-all" value={searchQuery} onChange={e => setSearchQuery(e.target.value)} data-id="element-13406" />
              </div>
              <Button variant={showFilters ? 'primary' : 'outline'} icon={<Search className="w-4 h-4" data-id="element-13408" />} onClick={() => setShowFilters(!showFilters)} className="shrink-0" data-id="element-13407">
                <span className="hidden sm:inline" data-id="element-13409">Фильтры</span>
              </Button>
            </div>
          </div>

          {/* Filters Panel */}
          {showFilters && <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 p-4 bg-slate-50 rounded-xl border border-slate-200 animate-in fade-in slide-in-from-top-2" data-id="element-13410">
              <div data-id="element-13411">
                <label className="block text-xs font-bold text-slate-500 uppercase tracking-wider mb-1.5" data-id="element-13412">
                  Тип операции
                </label>
                <select className="w-full px-3 py-2 bg-white border border-slate-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500" value={filterType} onChange={e => setFilterType(e.target.value as TxType | 'all')} data-id="element-13413">
                  <option value="all" data-id="element-13414">Все типы</option>
                  <option value="income" data-id="element-13415">Доход</option>
                  <option value="withdrawal" data-id="element-13416">Вывод средств</option>
                  <option value="subscription" data-id="element-13417">Подписка</option>
                  <option value="advertising" data-id="element-13418">Реклама</option>
                  <option value="refund" data-id="element-13419">Возврат</option>
                  <option value="commission" data-id="element-13420">Комиссия</option>
                </select>
              </div>
              <div data-id="element-13421">
                <label className="block text-xs font-bold text-slate-500 uppercase tracking-wider mb-1.5" data-id="element-13422">
                  Статус
                </label>
                <select className="w-full px-3 py-2 bg-white border border-slate-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500" value={filterStatus} onChange={e => setFilterStatus(e.target.value as TxStatus | 'all')} data-id="element-13423">
                  <option value="all" data-id="element-13424">Все статусы</option>
                  <option value="completed" data-id="element-13425">Выполнено</option>
                  <option value="pending" data-id="element-13426">В обработке</option>
                  <option value="failed" data-id="element-13427">Ошибка</option>
                </select>
              </div>
              <div className="flex items-end" data-id="element-13428">
                <Button variant="ghost" fullWidth className="text-slate-500 hover:text-slate-900 bg-white border border-slate-200" onClick={() => {
              setFilterType('all');
              setFilterStatus('all');
              setSearchQuery('');
            }} data-id="element-13429">
                  Сбросить фильтры
                </Button>
              </div>
            </div>}
        </div>

        {/* Desktop Table */}
        <div className="hidden md:block overflow-x-auto" data-id="element-13430">
          <table className="w-full text-left text-sm" data-id="element-13431">
            <thead className="bg-slate-50/50 text-slate-500 border-b border-slate-100" data-id="element-13432">
              <tr data-id="element-13433">
                <th className="px-6 py-4 font-semibold" data-id="element-13434">Дата</th>
                <th className="px-6 py-4 font-semibold" data-id="element-13435">Тип</th>
                <th className="px-6 py-4 font-semibold" data-id="element-13436">Описание</th>
                <th className="px-6 py-4 font-semibold" data-id="element-13437">Статус</th>
                <th className="px-6 py-4 font-semibold text-right" data-id="element-13438">Сумма</th>
                <th className="px-6 py-4 font-semibold w-10" data-id="element-13439"></th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100" data-id="element-13440">
              {paginatedTransactions.length > 0 ? paginatedTransactions.map(tx => {
              const isExpanded = expandedTxId === tx.id;
              const config = getTypeConfig(tx.type);
              return <Fragment key={tx.id} data-id="element-13441">
                      <tr className={`hover:bg-slate-50/80 transition-colors cursor-pointer ${isExpanded ? 'bg-slate-50/80' : ''}`} onClick={() => setExpandedTxId(isExpanded ? null : tx.id)} data-id="element-13442">
                        <td className="px-6 py-4 text-slate-500 whitespace-nowrap" data-id="element-13443">
                          {formatDate(tx.date)}
                        </td>
                        <td className="px-6 py-4" data-id="element-13444">
                          <div className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-md text-xs font-medium ${config.bg} ${config.color}`} data-id="element-13445">
                            {config.icon}
                            {config.label}
                          </div>
                        </td>
                        <td className="px-6 py-4 text-slate-900 font-medium" data-id="element-13446">
                          {tx.description}
                        </td>
                        <td className="px-6 py-4" data-id="element-13447">
                          {getStatusBadge(tx.status)}
                        </td>
                        <td className={`px-6 py-4 text-right font-bold whitespace-nowrap ${tx.amount > 0 ? 'text-emerald-600' : 'text-slate-900'}`} data-id="element-13448">
                          {tx.amount > 0 ? '+' : ''}
                          {formatMoney(tx.amount)}
                        </td>
                        <td className="px-6 py-4 text-slate-400" data-id="element-13449">
                          {isExpanded ? <ChevronUp className="w-5 h-5" data-id="element-13450" /> : <ChevronDown className="w-5 h-5" data-id="element-13451" />}
                        </td>
                      </tr>

                      {/* Expanded Details Row */}
                      {isExpanded && <tr className="bg-slate-50/50 border-b border-slate-200" data-id="element-13452">
                          <td colSpan={6} className="px-6 py-4" data-id="element-13453">
                            <div className="bg-white border border-slate-200 rounded-xl p-5 shadow-sm animate-in fade-in slide-in-from-top-2" data-id="element-13454">
                              <div className="grid grid-cols-2 md:grid-cols-4 gap-6" data-id="element-13455">
                                <div data-id="element-13456">
                                  <div className="text-xs text-slate-500 uppercase tracking-wider font-bold mb-1" data-id="element-13457">
                                    ID Транзакции
                                  </div>
                                  <div className="text-sm font-medium text-slate-900 font-mono" data-id="element-13458">
                                    {tx.id}
                                  </div>
                                </div>

                                {tx.orderId && <div data-id="element-13459">
                                    <div className="text-xs text-slate-500 uppercase tracking-wider font-bold mb-1" data-id="element-13460">
                                      Заказ
                                    </div>
                                    <div className="text-sm font-medium text-indigo-600 hover:underline cursor-pointer" onClick={e => {
                            e.stopPropagation();
                            if (setActiveTab) setActiveTab('orders');else showToast(`Заказ ${tx.orderId}`);
                          }} data-id="element-13461">
                                      {tx.orderId}
                                    </div>
                                  </div>}

                                {tx.clientName && <div data-id="element-13462">
                                    <div className="text-xs text-slate-500 uppercase tracking-wider font-bold mb-1" data-id="element-13463">
                                      Клиент
                                    </div>
                                    <div className="text-sm font-medium text-slate-900" data-id="element-13464">
                                      {tx.clientName}
                                    </div>
                                  </div>}

                                {tx.serviceName && <div data-id="element-13465">
                                    <div className="text-xs text-slate-500 uppercase tracking-wider font-bold mb-1" data-id="element-13466">
                                      Услуга
                                    </div>
                                    <div className="text-sm font-medium text-slate-900" data-id="element-13467">
                                      {tx.serviceName}
                                    </div>
                                  </div>}
                              </div>

                              {/* Commission Breakdown for Income */}
                              {tx.type === 'income' && tx.commissionAmount !== undefined && tx.netAmount !== undefined && <div className="mt-6 pt-4 border-t border-slate-100" data-id="element-13468">
                                    <div className="text-xs text-slate-500 uppercase tracking-wider font-bold mb-3" data-id="element-13469">
                                      Расчет выплаты
                                    </div>
                                    <div className="flex flex-col sm:flex-row gap-4 sm:gap-8 bg-slate-50 p-4 rounded-lg border border-slate-100" data-id="element-13470">
                                      <div data-id="element-13471">
                                        <div className="text-xs text-slate-500 mb-1" data-id="element-13472">
                                          Сумма заказа
                                        </div>
                                        <div className="font-medium text-slate-900" data-id="element-13473">
                                          {formatMoney(tx.amount)}
                                        </div>
                                      </div>
                                      <div className="hidden sm:flex items-center text-slate-300" data-id="element-13474">
                                        -
                                      </div>
                                      <div data-id="element-13475">
                                        <div className="text-xs text-slate-500 mb-1" data-id="element-13476">
                                          Комиссия платформы (
                                          {tx.commissionPercent}%)
                                        </div>
                                        <div className="font-medium text-rose-600" data-id="element-13477">
                                          -{formatMoney(tx.commissionAmount)}
                                        </div>
                                      </div>
                                      <div className="hidden sm:flex items-center text-slate-300" data-id="element-13478">
                                        =
                                      </div>
                                      <div data-id="element-13479">
                                        <div className="text-xs text-slate-500 mb-1" data-id="element-13480">
                                          Вы получаете на руки
                                        </div>
                                        <div className="font-bold text-emerald-600 text-lg" data-id="element-13481">
                                          {formatMoney(tx.netAmount)}
                                        </div>
                                      </div>
                                    </div>
                                  </div>}
                            </div>
                          </td>
                        </tr>}
                    </Fragment>;
            }) : <tr data-id="element-13482">
                  <td colSpan={6} className="px-6 py-12 text-center text-slate-500" data-id="element-13483">
                    <FileText className="w-12 h-12 text-slate-300 mx-auto mb-3" data-id="element-13484" />
                    <div className="text-lg font-medium text-slate-900 mb-1" data-id="element-13485">
                      Транзакции не найдены
                    </div>
                    <p data-id="element-13486">Попробуйте изменить параметры фильтрации или поиска</p>
                  </td>
                </tr>}
            </tbody>
          </table>
        </div>

        {/* Mobile List */}
        <div className="md:hidden divide-y divide-slate-100" data-id="element-13487">
          {paginatedTransactions.length > 0 ? paginatedTransactions.map(tx => {
          const isExpanded = expandedTxId === tx.id;
          const config = getTypeConfig(tx.type);
          return <div key={tx.id} className="flex flex-col" data-id="element-13488">
                  {/* Mobile Card Header */}
                  <div className={`p-4 flex flex-col gap-3 cursor-pointer ${isExpanded ? 'bg-slate-50' : 'bg-white'}`} onClick={() => setExpandedTxId(isExpanded ? null : tx.id)} data-id="element-13489">
                    <div className="flex justify-between items-start" data-id="element-13490">
                      <div className="flex items-center gap-2" data-id="element-13491">
                        <div className={`p-1.5 rounded-md ${config.bg} ${config.color}`} data-id="element-13492">
                          {config.icon}
                        </div>
                        <div data-id="element-13493">
                          <div className="font-bold text-slate-900 text-sm" data-id="element-13494">
                            {tx.description}
                          </div>
                          <div className="text-xs text-slate-500 mt-0.5" data-id="element-13495">
                            {formatDate(tx.date)}
                          </div>
                        </div>
                      </div>
                      <div className="text-right" data-id="element-13496">
                        <div className={`font-bold ${tx.amount > 0 ? 'text-emerald-600' : 'text-slate-900'}`} data-id="element-13497">
                          {tx.amount > 0 ? '+' : ''}
                          {formatMoney(tx.amount)}
                        </div>
                        <div className="mt-1" data-id="element-13498">{getStatusBadge(tx.status)}</div>
                      </div>
                    </div>
                  </div>

                  {/* Mobile Expanded Details */}
                  {isExpanded && <div className="p-4 bg-slate-50 border-t border-slate-100 animate-in fade-in slide-in-from-top-2" data-id="element-13499">
                      <div className="space-y-3" data-id="element-13500">
                        <div className="flex justify-between text-sm" data-id="element-13501">
                          <span className="text-slate-500" data-id="element-13502">ID Транзакции</span>
                          <span className="font-mono text-slate-900" data-id="element-13503">
                            {tx.id}
                          </span>
                        </div>

                        {tx.orderId && <div className="flex justify-between text-sm" data-id="element-13504">
                            <span className="text-slate-500" data-id="element-13505">Заказ</span>
                            <span className="font-medium text-indigo-600" onClick={e => {
                    e.stopPropagation();
                    if (setActiveTab) setActiveTab('orders');else showToast(`Заказ ${tx.orderId}`);
                  }} data-id="element-13506">
                              {tx.orderId}
                            </span>
                          </div>}

                        {tx.clientName && <div className="flex justify-between text-sm" data-id="element-13507">
                            <span className="text-slate-500" data-id="element-13508">Клиент</span>
                            <span className="font-medium text-slate-900" data-id="element-13509">
                              {tx.clientName}
                            </span>
                          </div>}

                        {/* Commission Breakdown for Mobile */}
                        {tx.type === 'income' && tx.commissionAmount !== undefined && tx.netAmount !== undefined && <div className="mt-4 pt-4 border-t border-slate-200 space-y-2" data-id="element-13510">
                              <div className="text-xs font-bold text-slate-500 uppercase mb-2" data-id="element-13511">
                                Расчет выплаты
                              </div>
                              <div className="flex justify-between text-sm" data-id="element-13512">
                                <span className="text-slate-600" data-id="element-13513">
                                  Сумма заказа
                                </span>
                                <span className="font-medium text-slate-900" data-id="element-13514">
                                  {formatMoney(tx.amount)}
                                </span>
                              </div>
                              <div className="flex justify-between text-sm" data-id="element-13515">
                                <span className="text-slate-600" data-id="element-13516">
                                  Комиссия ({tx.commissionPercent}%)
                                </span>
                                <span className="font-medium text-rose-600" data-id="element-13517">
                                  -{formatMoney(tx.commissionAmount)}
                                </span>
                              </div>
                              <div className="flex justify-between text-base pt-2 border-t border-slate-200 mt-2" data-id="element-13518">
                                <span className="font-bold text-slate-900" data-id="element-13519">
                                  На руки
                                </span>
                                <span className="font-bold text-emerald-600" data-id="element-13520">
                                  {formatMoney(tx.netAmount)}
                                </span>
                              </div>
                            </div>}
                      </div>
                    </div>}
                </div>;
        }) : <div className="p-8 text-center text-slate-500" data-id="element-13521">
              <FileText className="w-10 h-10 text-slate-300 mx-auto mb-3" data-id="element-13522" />
              <div className="text-base font-medium text-slate-900 mb-1" data-id="element-13523">
                Транзакции не найдены
              </div>
            </div>}
        </div>

        {/* Pagination */}
        {totalPages > 1 && <div className="p-4 border-t border-slate-100 flex flex-col sm:flex-row items-center justify-between gap-3" data-id="element-13524">
            <span className="text-xs text-slate-500" data-id="element-13525">
              Показано {(currentPage - 1) * ITEMS_PER_PAGE + 1}–
              {Math.min(currentPage * ITEMS_PER_PAGE, filteredTransactions.length)}{' '}
              из {filteredTransactions.length}
            </span>
            <Pagination currentPage={currentPage} totalPages={totalPages} onPageChange={setCurrentPage} data-id="element-13526" />
          </div>}
      </Card>

      {/* Withdraw Modal */}
      {showWithdrawModal && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/50 backdrop-blur-sm animate-in fade-in duration-200" data-id="element-13527">
          <div className="bg-white rounded-2xl shadow-xl w-full max-w-md overflow-hidden animate-in zoom-in-95 duration-200" data-id="element-13528">
            <div className="flex justify-between items-center p-5 border-b border-slate-100" data-id="element-13529">
              <h3 className="text-xl font-bold text-slate-900" data-id="element-13530">
                Вывод средств
              </h3>
              <button onClick={() => setShowWithdrawModal(false)} className="text-slate-400 hover:text-slate-600" data-id="element-13531">
                <X className="w-5 h-5" data-id="element-13532" />
              </button>
            </div>

            <div className="p-5 space-y-5" data-id="element-13533">
              {/* Amount Input */}
              <div data-id="element-13534">
                <label className="block text-sm font-bold text-slate-700 mb-2" data-id="element-13535">
                  Сумма вывода
                </label>
                <div className="relative" data-id="element-13536">
                  <input type="text" className="w-full pl-4 pr-12 py-3 text-2xl font-bold text-slate-900 bg-slate-50 border border-slate-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-indigo-500" placeholder="0" value={withdrawAmount} onChange={e => {
                const val = e.target.value.replace(/\D/g, '');
                setWithdrawAmount(val ? new Intl.NumberFormat('ru-RU').format(parseInt(val)) : '');
              }} data-id="element-13537" />
                  <span className="absolute right-4 top-1/2 -translate-y-1/2 text-xl font-bold text-slate-400" data-id="element-13538">
                    ₽
                  </span>
                </div>
                <div className="flex justify-between mt-2 text-sm" data-id="element-13539">
                  <span className="text-slate-500" data-id="element-13540">
                    Доступно:{' '}
                    <span className="font-bold text-slate-900" data-id="element-13541">
                      {formatMoney(availableToWithdraw)}
                    </span>
                  </span>
                  <button className="text-indigo-600 font-medium hover:underline" onClick={() => setWithdrawAmount(new Intl.NumberFormat('ru-RU').format(availableToWithdraw))} data-id="element-13542">
                    Вывести всё
                  </button>
                </div>
              </div>

              {/* Method Selector */}
              <div data-id="element-13543">
                <label className="block text-sm font-bold text-slate-700 mb-2" data-id="element-13544">
                  Куда перевести
                </label>
                <div className="space-y-2" data-id="element-13545">
                  {methods.map(method => <label key={method.id} className={`flex items-center justify-between p-3 rounded-xl border cursor-pointer transition-all ${selectedMethodId === method.id ? 'border-indigo-500 bg-indigo-50/30 ring-1 ring-indigo-500' : 'border-slate-200 hover:border-indigo-300'}`} data-id="element-13546">
                      <div className="flex items-center gap-3" data-id="element-13547">
                        <input type="radio" name="withdrawMethod" className="w-4 h-4 text-indigo-600 border-slate-300 focus:ring-indigo-500" checked={selectedMethodId === method.id} onChange={() => setSelectedMethodId(method.id)} data-id="element-13548" />
                        <div data-id="element-13549">
                          <div className="font-bold text-slate-900 text-sm" data-id="element-13550">
                            {method.details}
                          </div>
                          <div className="text-xs text-slate-500" data-id="element-13551">
                            {method.name}
                          </div>
                        </div>
                      </div>
                      <CreditCard className="w-5 h-5 text-slate-400" data-id="element-13552" />
                    </label>)}
                </div>
              </div>

              {/* Summary */}
              <div className="bg-slate-50 rounded-xl p-4 border border-slate-100 space-y-3" data-id="element-13553">
                <div className="flex justify-between text-sm" data-id="element-13554">
                  <span className="text-slate-500" data-id="element-13555">Комиссия за вывод</span>
                  <span className="font-medium text-slate-900" data-id="element-13556">0 ₽ (0%)</span>
                </div>
                <div className="flex justify-between text-sm" data-id="element-13557">
                  <span className="text-slate-500" data-id="element-13558">Срок зачисления</span>
                  <span className="font-medium text-slate-900" data-id="element-13559">
                    1-3 рабочих дня
                  </span>
                </div>
                <div className="pt-3 border-t border-slate-200 flex justify-between items-center" data-id="element-13560">
                  <span className="font-bold text-slate-900" data-id="element-13561">
                    Итого к получению
                  </span>
                  <span className="text-xl font-bold text-emerald-600" data-id="element-13562">
                    {withdrawAmount ? formatMoney(parseInt(withdrawAmount.replace(/\D/g, ''))) : '0 ₽'}
                  </span>
                </div>
              </div>

              <Button variant="primary" size="lg" fullWidth onClick={handleWithdraw} data-id="element-13563">
                Подтвердить вывод
              </Button>
            </div>
          </div>
        </div>}

      {/* Top-up Modal */}
      {showTopupModal && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/50 backdrop-blur-sm animate-in fade-in duration-200" data-id="element-13564">
          <div className="bg-white rounded-2xl shadow-xl w-full max-w-md overflow-hidden animate-in zoom-in-95 duration-200" data-id="element-13565">
            {topupStep < 5 && <div className="h-1 bg-slate-100" data-id="element-13566">
                <div className="h-1 bg-emerald-500 transition-all duration-500" style={{
            width: `${(topupStep + 1) / 5 * 100}%`
          }} data-id="element-13567" />
              </div>}

            <div className="p-5 space-y-4" data-id="element-13568">
              {/* Step 0: Amount */}
              {topupStep === 0 && <>
                  <div className="flex items-center justify-between" data-id="element-13569">
                    <h3 className="text-lg font-bold text-slate-900" data-id="element-13570">
                      Пополнение баланса
                    </h3>
                    <button onClick={resetTopup} className="p-1 text-slate-400 hover:text-slate-600" data-id="element-13571">
                      <X className="w-5 h-5" data-id="element-13572" />
                    </button>
                  </div>
                  <div className="grid grid-cols-2 gap-2" data-id="element-13573">
                    {TOPUP_AMOUNTS_ASTRO.map(amt => <button key={amt} onClick={() => {
                setTopupAmount(amt);
                setTopupCustom('');
              }} className={`py-3 px-3 rounded-xl text-sm font-bold transition-colors border ${topupAmount === amt ? 'bg-emerald-50 border-emerald-300 text-emerald-700' : 'bg-white border-slate-200 text-slate-700 hover:bg-slate-50'}`} data-id="element-13574">
                        {amt.toLocaleString('ru-RU')} ₽
                      </button>)}
                  </div>
                  <div className="relative" data-id="element-13575">
                    <input type="number" placeholder="Другая сумма" value={topupCustom} onChange={e => {
                setTopupCustom(e.target.value);
                setTopupAmount(null);
              }} className="w-full px-4 py-3 text-sm border border-slate-200 rounded-xl focus:outline-none focus:border-emerald-500" data-id="element-13576" />
                    <span className="absolute right-4 top-1/2 -translate-y-1/2 text-sm text-slate-400" data-id="element-13577">
                      ₽
                    </span>
                  </div>
                  <Button variant="primary" size="lg" fullWidth disabled={!topupFinalAmount || topupFinalAmount <= 0} className="bg-emerald-600 hover:bg-emerald-500" onClick={() => setTopupStep(1)} data-id="element-13578">
                    Далее — способ оплаты
                  </Button>
                </>}

              {/* Step 1: Method */}
              {topupStep === 1 && <>
                  <div className="flex items-center justify-between" data-id="element-13579">
                    <div className="flex items-center gap-2" data-id="element-13580">
                      <button onClick={() => setTopupStep(0)} className="p-1 text-slate-400 hover:text-slate-600" data-id="element-13581">
                        <ArrowLeft className="w-5 h-5" data-id="element-13582" />
                      </button>
                      <h3 className="text-lg font-bold text-slate-900" data-id="element-13583">
                        Способ оплаты
                      </h3>
                    </div>
                    <button onClick={resetTopup} className="p-1 text-slate-400 hover:text-slate-600" data-id="element-13584">
                      <X className="w-5 h-5" data-id="element-13585" />
                    </button>
                  </div>
                  <div className="text-sm text-slate-500" data-id="element-13586">
                    Сумма:{' '}
                    <span className="font-bold text-slate-900" data-id="element-13587">
                      {topupFinalAmount.toLocaleString('ru-RU')} ₽
                    </span>
                  </div>
                  <div className="space-y-2" data-id="element-13588">
                    {TOPUP_METHODS.map(m => <button key={m.id} onClick={() => setTopupMethod(m.id)} className={`w-full flex items-center gap-3 p-3 rounded-xl border transition-colors text-left ${topupMethod === m.id ? 'border-emerald-300 bg-emerald-50' : 'border-slate-200 hover:bg-slate-50'}`} data-id="element-13589">
                        <div className={`w-10 h-10 rounded-lg flex items-center justify-center shrink-0 ${topupMethod === m.id ? 'bg-emerald-100 text-emerald-600' : 'bg-slate-100 text-slate-500'}`} data-id="element-13590">
                          {m.icon}
                        </div>
                        <div data-id="element-13591">
                          <div className="text-sm font-bold text-slate-900" data-id="element-13592">
                            {m.label}
                          </div>
                          <div className="text-xs text-slate-500" data-id="element-13593">{m.desc}</div>
                        </div>
                        {topupMethod === m.id && <CheckCircle2 className="w-5 h-5 text-emerald-600 ml-auto shrink-0" data-id="element-13594" />}
                      </button>)}
                  </div>
                  <Button variant="primary" size="lg" fullWidth disabled={!topupMethod} className="bg-emerald-600 hover:bg-emerald-500" onClick={() => {
              if (topupMethod === 'card') setTopupStep(2);else setTopupStep(3);
            }} data-id="element-13595">
                    Далее
                  </Button>
                </>}

              {/* Step 2: Card Details */}
              {topupStep === 2 && <>
                  <div className="flex items-center justify-between" data-id="element-13596">
                    <div className="flex items-center gap-2" data-id="element-13597">
                      <button onClick={() => setTopupStep(1)} className="p-1 text-slate-400 hover:text-slate-600" data-id="element-13598">
                        <ArrowLeft className="w-5 h-5" data-id="element-13599" />
                      </button>
                      <h3 className="text-lg font-bold text-slate-900" data-id="element-13600">
                        Данные карты
                      </h3>
                    </div>
                    <button onClick={resetTopup} className="p-1 text-slate-400 hover:text-slate-600" data-id="element-13601">
                      <X className="w-5 h-5" data-id="element-13602" />
                    </button>
                  </div>

                  <div className="bg-gradient-to-br from-slate-800 to-slate-900 rounded-xl p-4 text-white space-y-3" data-id="element-13603">
                    <div className="flex justify-between items-start" data-id="element-13604">
                      <CreditCard className="w-8 h-8 text-slate-400" data-id="element-13605" />
                      <span className="text-xs text-slate-400 uppercase tracking-wider" data-id="element-13606">
                        {topupFinalAmount.toLocaleString('ru-RU')} ₽
                      </span>
                    </div>
                    <div className="text-lg font-mono tracking-widest" data-id="element-13607">
                      {topupCardNumber || '•••• •••• •••• ••••'}
                    </div>
                    <div className="flex justify-between text-xs text-slate-400" data-id="element-13608">
                      <span data-id="element-13609">{topupCardName || 'CARDHOLDER NAME'}</span>
                      <span data-id="element-13610">{topupCardExpiry || 'MM/YY'}</span>
                    </div>
                  </div>

                  <div className="space-y-3" data-id="element-13611">
                    <div data-id="element-13612">
                      <label className="text-xs text-slate-500 font-bold mb-1 block" data-id="element-13613">
                        Номер карты
                      </label>
                      <input type="text" value={topupCardNumber} placeholder="0000 0000 0000 0000" onChange={e => setTopupCardNumber(fmtCardNum(e.target.value))} className="w-full px-3 py-2.5 text-sm border border-slate-200 rounded-lg focus:outline-none focus:border-emerald-500 font-mono tracking-wider" maxLength={19} data-id="element-13614" />
                    </div>
                    <div className="grid grid-cols-2 gap-3" data-id="element-13615">
                      <div data-id="element-13616">
                        <label className="text-xs text-slate-500 font-bold mb-1 block" data-id="element-13617">
                          Срок
                        </label>
                        <input type="text" value={topupCardExpiry} placeholder="MM/YY" onChange={e => setTopupCardExpiry(fmtExp(e.target.value))} className="w-full px-3 py-2.5 text-sm border border-slate-200 rounded-lg focus:outline-none focus:border-emerald-500 font-mono" maxLength={5} data-id="element-13618" />
                      </div>
                      <div data-id="element-13619">
                        <label className="text-xs text-slate-500 font-bold mb-1 block" data-id="element-13620">
                          CVV
                        </label>
                        <input type="password" value={topupCardCvv} placeholder="•••" onChange={e => setTopupCardCvv(e.target.value.replace(/\D/g, '').slice(0, 4))} className="w-full px-3 py-2.5 text-sm border border-slate-200 rounded-lg focus:outline-none focus:border-emerald-500 font-mono" maxLength={4} data-id="element-13621" />
                      </div>
                    </div>
                    <div data-id="element-13622">
                      <label className="text-xs text-slate-500 font-bold mb-1 block" data-id="element-13623">
                        Имя на карте
                      </label>
                      <input type="text" value={topupCardName} placeholder="IVAN IVANOV" onChange={e => setTopupCardName(e.target.value.toUpperCase())} className="w-full px-3 py-2.5 text-sm border border-slate-200 rounded-lg focus:outline-none focus:border-emerald-500 uppercase" data-id="element-13624" />
                    </div>
                    <label className="flex items-center gap-2 cursor-pointer" data-id="element-13625">
                      <input type="checkbox" checked={topupSaveCard} onChange={e => setTopupSaveCard(e.target.checked)} className="w-4 h-4 rounded border-slate-300 text-emerald-600 focus:ring-emerald-500" data-id="element-13626" />
                      <span className="text-xs text-slate-600" data-id="element-13627">
                        Сохранить карту
                      </span>
                    </label>
                  </div>

                  <div className="flex items-center gap-2 text-xs text-slate-400" data-id="element-13628">
                    <Shield className="w-3.5 h-3.5 shrink-0" data-id="element-13629" /> Данные защищены
                    SSL-шифрованием
                  </div>
                  <Button variant="primary" size="lg" fullWidth disabled={!isTopupCardValid} className="bg-emerald-600 hover:bg-emerald-500" onClick={() => setTopupStep(3)} data-id="element-13630">
                    Оплатить {topupFinalAmount.toLocaleString('ru-RU')} ₽
                  </Button>
                </>}

              {/* Step 3: SMS */}
              {topupStep === 3 && <>
                  <div className="flex items-center justify-between" data-id="element-13631">
                    <div className="flex items-center gap-2" data-id="element-13632">
                      <button onClick={() => setTopupStep(topupMethod === 'card' ? 2 : 1)} className="p-1 text-slate-400 hover:text-slate-600" data-id="element-13633">
                        <ArrowLeft className="w-5 h-5" data-id="element-13634" />
                      </button>
                      <h3 className="text-lg font-bold text-slate-900" data-id="element-13635">
                        Подтверждение
                      </h3>
                    </div>
                    <button onClick={resetTopup} className="p-1 text-slate-400 hover:text-slate-600" data-id="element-13636">
                      <X className="w-5 h-5" data-id="element-13637" />
                    </button>
                  </div>

                  <div className="text-center py-3" data-id="element-13638">
                    <div className="w-14 h-14 rounded-2xl bg-emerald-50 flex items-center justify-center mx-auto mb-3" data-id="element-13639">
                      <Smartphone className="w-7 h-7 text-emerald-600" data-id="element-13640" />
                    </div>
                    <p className="text-sm text-slate-700 font-medium" data-id="element-13641">
                      Введите код из СМС
                    </p>
                    <p className="text-xs text-slate-400 mt-0.5" data-id="element-13642">
                      Отправлен на +7 (•••) •••-••-42
                    </p>
                  </div>

                  <div className="flex justify-center gap-2" data-id="element-13643">
                    {[0, 1, 2, 3].map(i => <input key={i} type="text" maxLength={1} value={topupSmsCode[i] || ''} onChange={e => {
                const digit = e.target.value.replace(/\D/g, '');
                const arr = topupSmsCode.split('');
                arr[i] = digit;
                setTopupSmsCode(arr.join(''));
                if (digit && i < 3) {
                  const next = e.target.nextElementSibling as HTMLInputElement;
                  if (next) next.focus();
                }
              }} onKeyDown={e => {
                if (e.key === 'Backspace' && !topupSmsCode[i] && i > 0) {
                  const prev = (e.target as HTMLElement).previousElementSibling as HTMLInputElement;
                  if (prev) prev.focus();
                }
              }} className="w-12 h-14 text-center text-2xl font-bold border-2 border-slate-200 rounded-xl focus:outline-none focus:border-emerald-500 transition-colors" data-id="element-13644" />)}
                  </div>

                  <div className="text-center" data-id="element-13645">
                    {topupSmsTimer > 0 ? <span className="text-xs text-slate-400" data-id="element-13646">
                        Повторно через {topupSmsTimer} сек
                      </span> : <button onClick={() => {
                setTopupSmsTimer(60);
                showToast('Код отправлен повторно');
              }} className="text-xs text-emerald-600 hover:underline" data-id="element-13647">
                        Отправить повторно
                      </button>}
                  </div>

                  <Button variant="primary" size="lg" fullWidth disabled={topupSmsCode.replace(/\s/g, '').length < 4} className="bg-emerald-600 hover:bg-emerald-500" onClick={() => setTopupStep(4)} data-id="element-13648">
                    Подтвердить
                  </Button>
                </>}

              {/* Step 4: Processing */}
              {topupStep === 4 && <div className="text-center py-10" data-id="element-13649">
                  <div className="w-16 h-16 rounded-full bg-emerald-50 flex items-center justify-center mx-auto mb-4" data-id="element-13650">
                    <Loader2 className="w-8 h-8 text-emerald-600 animate-spin" data-id="element-13651" />
                  </div>
                  <h4 className="font-bold text-slate-900" data-id="element-13652">
                    Обработка платежа...
                  </h4>
                  <p className="text-xs text-slate-400 mt-1" data-id="element-13653">
                    Не закрывайте окно
                  </p>
                  <div className="mt-4 flex justify-center gap-1" data-id="element-13654">
                    {[0, 1, 2].map(i => <div key={i} className="w-2 h-2 rounded-full bg-emerald-400 animate-pulse" style={{
                animationDelay: `${i * 0.3}s`
              }} data-id="element-13655" />)}
                  </div>
                </div>}

              {/* Step 5: Success */}
              {topupStep === 5 && <>
                  <div className="text-center py-4" data-id="element-13656">
                    <div className="w-16 h-16 rounded-full bg-emerald-50 flex items-center justify-center mx-auto mb-3" data-id="element-13657">
                      <Check className="w-8 h-8 text-emerald-600" data-id="element-13658" />
                    </div>
                    <h4 className="font-bold text-slate-900 text-lg" data-id="element-13659">
                      Баланс пополнен!
                    </h4>
                    <p className="text-sm text-slate-500 mt-0.5" data-id="element-13660">
                      +{topupFinalAmount.toLocaleString('ru-RU')} ₽
                    </p>
                  </div>

                  <div className="bg-slate-50 rounded-xl p-4 space-y-2 border border-slate-100" data-id="element-13661">
                    <div className="flex items-center gap-2 mb-2" data-id="element-13662">
                      <FileText className="w-4 h-4 text-slate-400" data-id="element-13663" />
                      <span className="text-sm font-bold text-slate-700" data-id="element-13664">
                        Чек
                      </span>
                    </div>
                    <div className="space-y-1.5" data-id="element-13665">
                      <div className="flex justify-between text-sm" data-id="element-13666">
                        <span className="text-slate-500" data-id="element-13667">Операция</span>
                        <span className="text-slate-900" data-id="element-13668">
                          Пополнение баланса
                        </span>
                      </div>
                      <div className="flex justify-between text-sm" data-id="element-13669">
                        <span className="text-slate-500" data-id="element-13670">Сумма</span>
                        <span className="text-slate-900 font-bold" data-id="element-13671">
                          {topupFinalAmount.toLocaleString('ru-RU')} ₽
                        </span>
                      </div>
                      <div className="flex justify-between text-sm" data-id="element-13672">
                        <span className="text-slate-500" data-id="element-13673">Способ</span>
                        <span className="text-slate-900" data-id="element-13674">
                          {TOPUP_METHODS.find(m => m.id === topupMethod)?.label || ''}
                          {topupMethod === 'card' && topupCardNumber ? ` •••• ${topupCardNumber.slice(-4)}` : ''}
                        </span>
                      </div>
                      <div className="flex justify-between text-sm" data-id="element-13675">
                        <span className="text-slate-500" data-id="element-13676">Дата</span>
                        <span className="text-slate-900" data-id="element-13677">
                          {new Date().toLocaleString('ru-RU', {
                      day: '2-digit',
                      month: 'short',
                      year: 'numeric',
                      hour: '2-digit',
                      minute: '2-digit'
                    })}
                        </span>
                      </div>
                      <div className="flex justify-between text-sm" data-id="element-13678">
                        <span className="text-slate-500" data-id="element-13679">Статус</span>
                        <Badge variant="success" size="sm" data-id="element-13680">
                          <CheckCircle2 className="w-3 h-3 mr-0.5" data-id="element-13681" /> Успешно
                        </Badge>
                      </div>
                    </div>
                  </div>

                  <div className="flex gap-2" data-id="element-13682">
                    <Button variant="outline" size="lg" className="flex-1" onClick={() => showToast('Чек отправлен на email')} data-id="element-13683">
                      <Receipt className="w-4 h-4 mr-1" data-id="element-13684" /> Чек на email
                    </Button>
                    <Button variant="primary" size="lg" className="flex-1 bg-emerald-600 hover:bg-emerald-500" onClick={resetTopup} data-id="element-13685">
                      Готово
                    </Button>
                  </div>
                </>}
            </div>
          </div>
        </div>}

      {/* Download Modal */}
      {showDownloadModal && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/50 backdrop-blur-sm animate-in fade-in duration-200" data-id="element-13686">
          <div className="bg-white rounded-2xl shadow-xl w-full max-w-sm overflow-hidden animate-in zoom-in-95 duration-200" data-id="element-13687">
            <div className="flex justify-between items-center p-5 border-b border-slate-100" data-id="element-13688">
              <h3 className="text-lg font-bold text-slate-900" data-id="element-13689">
                Скачать выписку
              </h3>
              <button onClick={() => setShowDownloadModal(false)} className="text-slate-400 hover:text-slate-600" data-id="element-13690">
                <X className="w-5 h-5" data-id="element-13691" />
              </button>
            </div>

            <div className="p-5 space-y-4" data-id="element-13692">
              <div data-id="element-13693">
                <label className="block text-sm font-bold text-slate-700 mb-2" data-id="element-13694">
                  Период
                </label>
                <select className="w-full px-3 py-2 bg-white border border-slate-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500" value={downloadPeriod} onChange={e => setDownloadPeriod(e.target.value)} data-id="element-13695">
                  <option value="week" data-id="element-13696">За неделю</option>
                  <option value="month" data-id="element-13697">За месяц</option>
                  <option value="quarter" data-id="element-13698">За квартал</option>
                  <option value="year" data-id="element-13699">За год</option>
                  <option value="all" data-id="element-13700">За всё время</option>
                </select>
              </div>

              <div data-id="element-13701">
                <label className="block text-sm font-bold text-slate-700 mb-2" data-id="element-13702">
                  Тип операций
                </label>
                <select className="w-full px-3 py-2 bg-white border border-slate-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500" value={downloadType} onChange={e => setDownloadType(e.target.value)} data-id="element-13703">
                  <option value="all" data-id="element-13704">Все операции</option>
                  <option value="income" data-id="element-13705">Только доходы</option>
                  <option value="withdrawal" data-id="element-13706">Только выводы</option>
                </select>
              </div>

              <div className="pt-2" data-id="element-13707">
                <Button variant="primary" fullWidth icon={<Download className="w-4 h-4" data-id="element-13709" />} onClick={handleDownload} data-id="element-13708">
                  Скачать CSV
                </Button>
              </div>
            </div>
          </div>
        </div>}
    </div>;
}